The date & time the job ad was successfully posted within SEEK's systems. This corresponds to the `Event.createDateTime` field in the GraphQL schema.
